<template>
  <Button class="p-button-secondary p-button-sm cancelbtn ms-2" @click="$emit('canclebtn')">
    <span class="label">{{ btnname }}<span class="sublabel ms-2" v-if="sublabel">{{ sublabel }}</span></span>
  </Button>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    btnname: {
      type: String,
      default: "Cancel",
    },
    sublabel: {
      type: String,
      default: ""
    },
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss">
@import "../../assets/variables.scss";

.cancelbtn {
  // background-color: $AddButton !important;
  border: none !important;
  padding: 0.5rem 0.65rem 0.5rem 0.65rem !important;
  font-size: 14px !important;
  white-space: nowrap;
  border-radius: 8px !important;

  i {
    font-size: 12px;
  }

  img {
    width: 13px;
    margin-right: 5px;
  }

  .label {
    font-weight: 500;
  }

  .sublabel {
    font-size: 9px !important;
    font-weight: 400;
  }
}
</style>
